// @file Types for slideshow

export enum PageType {
  Cover = 'cover',
  Section = 'section',
  Group = 'group',
  Post = 'post',
}

export interface Page {
  pageType: PageType
  entityId?: string
}
